import { useSelector } from 'react-redux'
import { isLoaded, useFirestoreConnect } from 'react-redux-firebase'
import type { RootState } from 'state/store.types'
import type { Manager } from 'types/manager'

export const useSelectedManager = () => {
	const selectedManagerUUID =
		useSelector((state: RootState) => state.app.selectedManagerUUID) ||
		'empty-value'

	useFirestoreConnect([
		{
			collection: 'manager',
			storeAs: `selectedManager_${selectedManagerUUID}`,
			where: ['uuid', '==', selectedManagerUUID],
			limit: 1,
		},
	])

	return useSelector(({ firestoreReducer }: RootState) => {
		const managers =
			firestoreReducer.ordered[`selectedManager_${selectedManagerUUID}`]
		if (!isLoaded(managers)) {
			return { loading: true, selectedManager: null }
		}
		return { loading: false, selectedManager: managers[0] as Manager }
	})
}
